import { e as error, j as json } from "../../../../../../chunks/index2.js";
import { h as handleRequest } from "../../../../../../chunks/utils.js";
import { a as sendLicenseVerifiedEmail } from "../../../../../../chunks/mailer.js";
import admin from "firebase-admin";
const GET = handleRequest(async ({ url, locals, fetch }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  const code = searchParams.get("code");
  if (!email || !code) {
    return error(400, { message: "No email or code provided" });
  }
  const licenseRef = await admin.firestore().collection("licenses").doc(email).get();
  const license = licenseRef.data();
  const success = license?.code === code;
  if (!success) return error(403, { message: "Invalid license code" });
  await sendLicenseVerifiedEmail(email);
  await admin.firestore().collection("users").doc(locals.user?.id).set(
    { license: "premium", trialAvailability: false, trialStartDate: null },
    { merge: true }
  );
  return json(
    {
      success
    },
    {
      status: success ? 200 : 403
    }
  );
});
export {
  GET
};
